var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-section',{attrs:{"title":_vm.$t('Automations_Import_Title_Schedule')}},[_c('recurrence-settings',{attrs:{"model":_vm.model.schedule,"timezone":_vm.$store.state.app.project.timezone,"disabled":_vm.readonly}})],1),_vm._v(" "),(
      _vm.$hasFeature('featureAutomationCampaignExecution') &&
        _vm.model.type === 'profiles'
    )?_c('form-section',{attrs:{"title":_vm.$t('Automations_Import_Title_CampaignTrigger')}},[_c('campaign-execution-settings',{attrs:{"model":_vm.model.config,"disabled":_vm.readonly}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c68ffa3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/automations/components/StepImportSchedule.vue
// module id = null
// module chunks = 